export enum AdminMachinesRoutes {
  CheckFirmware = 'check-firmware',
  CreateForTeam = 'create-for-team',
  GetActiveModels = 'get-active-models',
  GetConfig = 'get-config',
  GetDetails = 'get-details',
  GetErrors = 'get-errors',
  GetLogs = 'get-logs',
  GetMachines = 'get-machines',
  GetPitchPerformance = 'get-pitch-performance',
  GetRecentSessions = 'get-recent-sessions',
  GetRepeatabilityImages = 'get-repeatability-images',
  PostCustomRequest = 'post-custom-request',
  ResetConnections = 'reset-connections',
  RestartMachine = 'restart-machine',
  SideloadWebSocket = 'sideload-web-socket',
  UpdateConfig = 'update-config',
  UpdateMachine = 'update-machine',
  UpgradeFirmware = 'upgrade-firmware',
}
